
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","viewBox":"0 0 22 22"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#ef5350","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"d":"M13.658 1.833H8.341a3.185 3.185 0 00-1.943.807L2.64 6.398a3.185 3.185 0 00-.807 1.943v5.317a3.185 3.185 0 00.807 1.943l3.758 3.758a3.185 3.185 0 001.943.807h5.317a3.185 3.185 0 001.943-.807l3.758-3.758a3.185 3.185 0 00.807-1.943V8.341a3.185 3.185 0 00-.807-1.943L15.601 2.64a3.185 3.185 0 00-1.943-.807z"}}),_c('path',{attrs:{"d":"M4.528 17.49L17.49 4.528","opacity":".4"}})])])
          )
        }
      }
    